// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditTimeOffModal_editTimeOffModal__Xtb92 .EditTimeOffModal_formWrp__S\\+3Vj {
  padding: 0;
}
.EditTimeOffModal_editTimeOffModal__Xtb92 .EditTimeOffModal_formWrp__S\\+3Vj .EditTimeOffModal_formField__m0Pl6 {
  margin-bottom: 16px;
}
.EditTimeOffModal_editTimeOffModal__Xtb92 .EditTimeOffModal_formWrp__S\\+3Vj .EditTimeOffModal_formField__m0Pl6 .EditTimeOffModal_label__irUyH {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}
.EditTimeOffModal_editTimeOffModal__Xtb92 .EditTimeOffModal_footerBtns__aElxK {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
}
@media (max-width: 767px) {
  .EditTimeOffModal_editTimeOffModal__Xtb92 .EditTimeOffModal_footerBtns__aElxK {
    flex-direction: column;
    gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/modal/EditTimeOffModal.module.scss"],"names":[],"mappings":"AACC;EACC,UAAA;AAAF;AAEE;EACC,mBAAA;AAAH;AAEG;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAKC;EACC,aAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;AAHF;AAKE;EAND;IAOE,sBAAA;IACA,QAAA;EAFD;AACF","sourcesContent":[".editTimeOffModal {\r\n\t.formWrp {\r\n\t\tpadding: 0;\r\n\t\t\r\n\t\t.formField {\r\n\t\t\tmargin-bottom: 16px;\r\n\t\t\t\r\n\t\t\t.label {\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tfont-size: 14px;\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: #374151;\r\n\t\t\t\tmargin-bottom: 6px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t\r\n\t.footerBtns {\r\n\t\tdisplay: flex;\r\n\t\tgap: 12px;\r\n\t\tjustify-content: flex-end;\r\n\t\twidth: 100%;\r\n\t\t\r\n\t\t@media (max-width: 767px) {\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 8px;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editTimeOffModal": `EditTimeOffModal_editTimeOffModal__Xtb92`,
	"formWrp": `EditTimeOffModal_formWrp__S+3Vj`,
	"formField": `EditTimeOffModal_formField__m0Pl6`,
	"label": `EditTimeOffModal_label__irUyH`,
	"footerBtns": `EditTimeOffModal_footerBtns__aElxK`
};
export default ___CSS_LOADER_EXPORT___;
